// src/components/BrandLogo.jsx
import { Image } from "@chakra-ui/react";

export default function BrandLogo({ size = 40 }) {
  return (
    <Image
      src="https://www.postcode.coupons/logo512.png"
      alt="Postcode Coupons"
      boxSize={size}          // supports responsive values
      maxW="100%"             // prevents overflow
      objectFit="contain"
    />
  );
}
